import { ButtonController } from "@quest/murka-games-behavior-panther/dist";

/**
 * ButtonControllerGame class handles the  console panelo of the base game and its buttons.
 */
export class ButtonControllerGame extends ButtonController {


}
